module.exports = __webpack_public_path__ + "img/监控设备.6f07f03a.png";